import { useState } from 'react';

export const useConfirmationPopup = () => {
  const [confirmationPopupState, setConfirmationPopupState] = useState({ visible: false });

  const actions = {
    close: () => setConfirmationPopupState({ visible: false }),
    open: ({ confirmAction }) => setConfirmationPopupState({ visible: true, confirmAction }),
    confirm: () => {
      confirmationPopupState.confirmAction && confirmationPopupState.confirmAction();
      setConfirmationPopupState({ visible: false });
    },
  };

  return [confirmationPopupState, actions];
};
